/*
 * GS Quick Add (collection cards, T-shirts only)
 * Icon on product card -> bottom sheet (colour + size) -> tap an available size
 * -> adds that exact variant using the theme's cart-drawer and opens the drawer.
 */
(function () {
  if (window.GSQuickAdd) return;

  var CLOSE_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function GSQuickAdd() {
    this.root = null;
    this.data = null;
    this.color = null;
    this.opener = null;
    this.busy = false;
    this.onKeyUp = this.onKeyUp.bind(this);

    var self = this;
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('[data-gs-quick-add]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        self.openFor(button);
      },
      true
    );
  }

  GSQuickAdd.prototype.build = function () {
    if (this.root) return;
    var self = this;

    var root = el('div', 'gs-qa');
    root.hidden = true;
    root.innerHTML =
      '<div class="gs-qa__overlay" data-gs-qa-close></div>' +
      '<div class="gs-qa__panel" role="dialog" aria-modal="true" aria-labelledby="GsQaHeading" tabindex="-1">' +
      '<div class="gs-qa__header">' +
      '<h2 class="gs-qa__heading" id="GsQaHeading">Select size</h2>' +
      '<button type="button" class="gs-qa__close" data-gs-qa-close aria-label="Close">' + CLOSE_ICON + '</button>' +
      '</div>' +
      '<div class="gs-qa__body">' +
      '<div class="gs-qa__product">' +
      '<div class="gs-qa__thumb-wrap"><img class="gs-qa__thumb" alt="" width="120" height="120"></div>' +
      '<div class="gs-qa__meta"><p class="gs-qa__title"></p><p class="gs-qa__color-name"></p></div>' +
      '</div>' +
      '<div class="gs-qa__swatches" role="radiogroup"></div>' +
      '<ul class="gs-qa__sizes" role="list"></ul>' +
      '<p class="gs-qa__error" role="alert" hidden></p>' +
      '<a class="gs-qa__details" href="#">View full details &amp; size guide</a>' +
      '</div>' +
      '</div>';
    document.body.appendChild(root);

    this.root = root;
    this.panel = root.querySelector('.gs-qa__panel');
    this.thumb = root.querySelector('.gs-qa__thumb');
    this.titleEl = root.querySelector('.gs-qa__title');
    this.colorNameEl = root.querySelector('.gs-qa__color-name');
    this.swatchesEl = root.querySelector('.gs-qa__swatches');
    this.sizesEl = root.querySelector('.gs-qa__sizes');
    this.errorEl = root.querySelector('.gs-qa__error');
    this.detailsEl = root.querySelector('.gs-qa__details');

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-gs-qa-close]')) {
        event.preventDefault();
        self.close(true);
        return;
      }
      var swatch = event.target.closest('[data-gs-qa-color]');
      if (swatch && !swatch.disabled) {
        self.color = swatch.getAttribute('data-gs-qa-color');
        self.render();
        return;
      }
      var size = event.target.closest('[data-gs-qa-variant]');
      if (size && !size.disabled && size.getAttribute('aria-disabled') !== 'true') {
        self.add(size);
      }
    });
  };

  GSQuickAdd.prototype.openFor = function (button) {
    var wrapper = button.closest('.card-wrapper') || button.parentElement;
    var script = wrapper && wrapper.querySelector('script[data-gs-quick-add-data]');
    if (!script) return;
    try {
      this.data = JSON.parse(script.textContent);
    } catch (e) {
      console.error('GS Quick Add: could not read product data', e);
      return;
    }

    this.build();
    this.opener = button;

    // Start on the card's colour, falling back to the first colour with stock.
    var colors = this.data.colors || [];
    // Prefer a colour the shopper picked with the card's swatches.
    var start = (wrapper && wrapper.getAttribute('data-gs-selected-color')) || this.data.selectedColor;
    if (!this.colorHasStock(start)) {
      start = null;
      for (var i = 0; i < colors.length; i++) {
        if (this.colorHasStock(colors[i].name)) {
          start = colors[i].name;
          break;
        }
      }
    }
    this.color = start || (colors[0] && colors[0].name);

    this.titleEl.textContent = this.data.title;
    var cardLink = wrapper && wrapper.querySelector('a[id^="CardLink-"]');
    this.detailsEl.setAttribute('href', (cardLink && cardLink.getAttribute('href')) || this.data.url);
    this.swatchesEl.setAttribute('aria-label', this.data.colorLabel || 'Color');
    this.errorEl.hidden = true;
    this.render();
    this.show();
  };

  GSQuickAdd.prototype.colorHasStock = function (color) {
    if (!color || !this.data) return false;
    return this.data.variants.some(function (v) {
      return v.color === color && v.available;
    });
  };

  GSQuickAdd.prototype.variantFor = function (color, size) {
    var list = this.data.variants;
    for (var i = 0; i < list.length; i++) {
      if (list[i].color === color && list[i].size === size) return list[i];
    }
    return null;
  };

  GSQuickAdd.prototype.render = function () {
    var self = this;
    var data = this.data;

    // Image: variant image for this colour, else product image.
    var image = data.image;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].color === this.color && data.variants[i].image) {
        image = data.variants[i].image;
        break;
      }
    }
    if (image) {
      this.thumb.src = image;
      this.thumb.alt = data.title + ' - ' + this.color;
      this.thumb.parentElement.hidden = false;
    } else {
      this.thumb.parentElement.hidden = true;
    }
    this.colorNameEl.textContent = this.color || '';

    // Colour swatches
    this.swatchesEl.innerHTML = '';
    data.colors.forEach(function (c) {
      var hasStock = self.colorHasStock(c.name);
      var b = el('button', 'gs-qa__swatch');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-gs-qa-color', c.name);
      b.setAttribute('aria-checked', c.name === self.color ? 'true' : 'false');
      b.setAttribute('aria-label', c.name + (hasStock ? '' : ' - sold out'));
      b.title = c.name;
      if (c.swatch) b.style.setProperty('--gs-qa-swatch', c.swatch);
      if (!hasStock) {
        b.disabled = true;
        b.classList.add('gs-qa__swatch--unavailable');
      }
      self.swatchesEl.appendChild(b);
    });

    // Sizes for the selected colour
    this.sizesEl.innerHTML = '';
    data.sizes.forEach(function (size) {
      var v = self.variantFor(self.color, size);
      var li = el('li', 'gs-qa__size-item');
      var b = el('button', 'gs-qa__size');
      b.type = 'button';
      var label = el('span', 'gs-qa__size-label', size);
      var right = el('span', 'gs-qa__size-price');

      if (v && v.available) {
        b.setAttribute('data-gs-qa-variant', v.id);
        b.setAttribute('aria-label', 'Add ' + self.color + ' / ' + size + ' to cart, ' + v.price);
        right.textContent = v.price;
      } else {
        b.disabled = true;
        b.classList.add('gs-qa__size--unavailable');
        right.textContent = v ? 'Sold out' : 'Unavailable';
        b.setAttribute('aria-label', size + ' ' + right.textContent);
      }

      b.appendChild(label);
      b.appendChild(right);
      li.appendChild(b);
      self.sizesEl.appendChild(li);
    });
  };

  GSQuickAdd.prototype.show = function () {
    var self = this;
    this.root.hidden = false;
    document.body.classList.add('gs-qa-open');
    requestAnimationFrame(function () {
      self.root.classList.add('gs-qa--active');
      if (typeof trapFocus === 'function') {
        trapFocus(self.panel, self.root.querySelector('.gs-qa__close'));
      } else {
        self.root.querySelector('.gs-qa__close').focus();
      }
    });
    document.addEventListener('keyup', this.onKeyUp);
  };

  GSQuickAdd.prototype.close = function (restoreFocus) {
    if (!this.root || this.root.hidden) return;
    var self = this;
    this.root.classList.remove('gs-qa--active');
    document.body.classList.remove('gs-qa-open');
    document.removeEventListener('keyup', this.onKeyUp);
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(restoreFocus ? this.opener : null);
    } else if (restoreFocus && this.opener) {
      this.opener.focus();
    }
    // Opened from inside the cart drawer (upsell row): hand the focus trap back to the drawer.
    var openDrawer = restoreFocus && this.opener && this.opener.closest('cart-drawer.active');
    if (openDrawer && typeof trapFocus === 'function') {
      trapFocus(document.getElementById('CartDrawer'), this.opener);
    }
    setTimeout(function () {
      if (!self.root.classList.contains('gs-qa--active')) self.root.hidden = true;
    }, 250);
  };

  GSQuickAdd.prototype.onKeyUp = function (event) {
    if (event.code === 'Escape' || event.key === 'Escape') this.close(true);
  };

  GSQuickAdd.prototype.showError = function (message) {
    this.errorEl.textContent = message || 'Sorry, something went wrong. Please try again.';
    this.errorEl.hidden = false;
  };

  GSQuickAdd.prototype.add = function (button) {
    if (this.busy) return;
    var self = this;
    var variantId = button.getAttribute('data-gs-qa-variant');
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    this.busy = true;
    this.errorEl.hidden = true;
    button.classList.add('gs-qa__size--loading');
    button.setAttribute('aria-disabled', 'true');
    this.root.classList.add('gs-qa--busy');

    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          self.showError(response.description || response.message);
          return;
        }

        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });
        }

        self.close(false);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(self.opener);
        cart.classList.remove('is-empty');
        setTimeout(function () {
          cart.renderContents(response);
        });
      })
      .catch(function (e) {
        console.error(e);
        self.showError();
      })
      .finally(function () {
        self.busy = false;
        button.classList.remove('gs-qa__size--loading');
        button.removeAttribute('aria-disabled');
        if (self.root) self.root.classList.remove('gs-qa--busy');
      });
  };

  window.GSQuickAdd = new GSQuickAdd();
})();
